import { Box, Text } from '@chakra-ui/react'
import { useBoolean } from 'react-use'
import { Button, Modal } from 'uikit'
import { useChangeIDXState } from './services/useChangeIDXState'
import { userIdxStatus } from 'shared/constants/user'

export const ChangeIDXState = ({ userId, idxRegistrationStatus, isDisabled }) => {
  const { mutate, isLoading } = useChangeIDXState(userId)
  const [isOpen, setOpenModal] = useBoolean(false)
  const disabledIdxRegistration = idxRegistrationStatus === userIdxStatus.IDX_TYPE_INVALID

  const handleSubmit = () => {
    mutate(!disabledIdxRegistration)
    setOpenModal(false)
  }

  return (
    <>
      <Button width="100%" onClick={() => setOpenModal(true)} loading={isLoading} disabled={isDisabled}>
        {disabledIdxRegistration ? 'Подключить IDX' : 'Отключить IDX'}
      </Button>
      <Modal isOpen={isOpen} onClose={() => setOpenModal(false)} title="Сменить статус IDX">
        <Text>
          Вы уверены, что хотите {disabledIdxRegistration ? 'включить' : 'отключить'} IDX?
        </Text>
        <Box pt="30px">
          <Button colorPalette="orange" loading={isLoading} onClick={handleSubmit}>
            Продолжить
          </Button>
        </Box>
      </Modal>
    </>
  )
}
